<template>
	<div id="products-results-page">
		<section class="products-section">
			<div class="container oversized-container">

				<breadcrumbs v-if="!justOneRow" :crumbs="[{ link: '/', label: 'Inicio' }, { label: 'Equipos' }]" />

				<div class="row">

					<div class="col-12 col-title-s1">
						<h3 class="title">{{ title }}</h3>
					</div>

					<ui-tabs v-model="slectedTab" class="mt-3" :options="hardwareOptions" disable-button-mode auto-select-first/>

					<!-- slectedTab: {{ slectedTab }} -->
					
					<filters-handler v-if="!justOneRow" class="mb-4 mt-4" v-model="filterCfg" :items-count="products.length" :per-page="perPage"/>
					
					<div class="col-12 col-products">
						<div class="row sample-products-wrapper xxl-5e">

							<div class="col-6 col-sm-6 col-md-4 col-lg-3 sample-product" v-for="product in productsPaginated">
								<router-link class="outlined-box highlightOnHover" :to="'/equipo/' + product.id">
									<div class="box-image">
										<div class="img">
											<!-- <img :src="product.image_url"> -->
											<api-img :comp="product.imagenes_id" />
										</div>
									</div>

									<div class="box-shot-descr">
										<h6 class="name">{{ product.nombre }}</h6>
										<h6 class="modelo">{{ product.modelo }}</h6>
										<!-- <h6 class="sku">{{ product.marca }}</h6> -->
										<h6 class="brand">{{ product.marca }}</h6>
										<h6 class="price">{{ product.precio | currency }} MXN</h6>

										<router-link class="btn-product" :to="'/equipo/' + product.id">
											Ver
											producto
										</router-link>

										{{ product.hardware_ptt === '1' ? 'Con PTT' : 'Sin PTT' }}
									</div>
								</router-link>
							</div>

						</div>
					</div>

					<div class="col-12" v-if="!catalogosGetProductos.length">
						<b-jumbotron header="Sin productos" lead="En éste momento no tenemos productos disponibles.">
							<p>
								Regresa pronto a ver los nuevos productos que iremos agregando.
							</p>
						</b-jumbotron>
					</div>

					<div class="col-12" v-else-if="productsPaginated.length === 0">
						<b-jumbotron header="Resultados no encontrados" lead="No se encontraron productos que coincidan con los filtros seleccionados.">
							<p>
								Intenta ajustar los filtros o busca otro término.
							</p>
						</b-jumbotron>
					</div>

				</div>

				<div class="text-right" v-if="justOneRow">
					<b-button variant="primary" class="btn-view-more" :to="'/equipos'">
						Ver mas
						<span class="imoon-chevron-right"></span>
					</b-button>
				</div>

			</div>
		</section>
	</div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex';
import filtersHandler from '../daniel/filtersHandler.vue';
const hardwareOptions = [
	{ key: 'ptt', label: 'Con PTT' },
	{ key: 'noPtt', label: 'Sin PTT' },
];
export default {
	name: 'ProductsIndex',
	components: {
		filtersHandler,
	},
	props: {
		hardwareOptions: {
			type: Array,
			default: () => hardwareOptions
		},
		title: {
			type: String,
			default: 'Equipos'
		},
		perPage: {
            type: Number,
            default: 30
        },
		justOneRow: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			slectedTab: 'ptt',
			filterCfg: {
				term: '',
				page: 1,
				args: { }
			}
			// products: [
			// 	{
			// 		id: 5,
			// 		image_url: "public/images/pages/products/product-1.jpg",
			// 		nombre: "Celular Samsung A12 5ta generación",
			// 	},
			// ],
		};
	},
	computed: {
		...mapGetters(['catalogosGetProductos']),
		productsPaginated() {
			const start = (this.filterCfg.page - 1) * this.perPage;
			const end = start + this.perPage;
			return this.products.slice(start, end);
		},
		products() {
			let filtered = _.filter(this.catalogosGetProductos, item => {
				// Prefilter by hardware_ptt based on selected tab
				if (item.hardware_ptt !== (this.slectedTab === 'ptt' ? '1' : '0')) {
					return false;
				}
				/**
				 * {"id":"1","nombre":"uPhone","created":"2025-05-28 19:59:43","modified":"2025-05-28 21:18:06","precio":"18999.00","descripcion":"A long description","descripcion_corta":"A short description","modelo":"X20","marca":"Uphone","existencia":"1","imagenes_id":"41","hardware_ptt":"1"}
				 */
				if (this.filterCfg.term && this.filterCfg.term.trim() !== '') {
					const term = this.filterCfg.term.trim().toLowerCase();
					return (
						(item.nombre && item.nombre.toLowerCase().includes(term)) ||
						(item.modelo && item.modelo.toLowerCase().includes(term)) ||
						(item.marca && item.marca.toLowerCase().includes(term))
					);
				} else {
					return true;
				}
			});
			if (this.justOneRow) 
				return filtered.slice(0, 5);
			
			return filtered;
		}
	}
};
</script>

<style lang="scss">
@import '@/sass/utils/variables.scss';

#products-results-page {

	.products-section {
		.container {

			padding-top: 12px;
			padding-bottom: 26px;

			.col-products {

				// padding: 0;

				.sample-product {
					.outlined-box {
						padding: 0.5em;

						.box-image {
							.img {
								background-color: white;
								width: 100%;
								height: 100%;
								border-radius: 0.1em;
			
								img {
									object-fit: contain;
									width: 100%;
									height: 100%;
								}
							}
						}
			
						.box-shot-descr {
							padding: none;
							color: white;
			
							.price {
								/* margin-bottom: 5px; */
								/* color: #000000; */
								color: $accent;
							}
			
							.btn-product {
								margin-top: 0;
								font-size: 1em;
								border: $primary-dark-border;
								text-transform: uppercase;
								display: none;
							}
			
							.name {
								margin-bottom: 0;
								min-height: none;
								max-height: none;
								color: white;
								font-size: 1em;
							}
						}
					}
				}
			}
		}
	}
}
</style>